import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  isCompleteForRadarResponse,
  isFlightsResponseSuccessAndValid,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/flightsResponse';

import type {
  MutationResponseAction,
  QueryResponseAction,
  SearchParamsChangedAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export default function (
  state: boolean = false,
  action: MutationResponseAction | QueryResponseAction | SearchParamsChangedAction,
): boolean {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const { response, type } = action.payload;
      if (type === RADAR_CREATE_SESSIONS || type === RADAR_POLL) {
        if (!isFlightsResponseSuccessAndValid(type, response)) {
          return state;
        }

        const agentsAreComplete = isCompleteForRadarResponse(response);

        return !action.error && agentsAreComplete ? true : state;
      }

      return state;
    }

    case SEARCH_PARAMS_CHANGED:
      return false;

    default: {
      return state;
    }
  }
}
export const get = (state: boolean): boolean => state;
